import { Contact } from "../components";

export function ContactContainer({ children }) {
  return (
    <Contact>
      <Contact.Box>
        <Contact.Text>questions?</Contact.Text>
        <Contact.Text>
          send me a <span>message</span>...
        </Contact.Text>
        <Contact.Email href="mailto: aldothedev@gmail.com">
          contact me
        </Contact.Email>
      </Contact.Box>
    </Contact>
  );
}
